import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import Tracking from "components/Tracking";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import MultiStepBookingForm from './pages/multi-step-booking-form';
import AnalyticsDashboard from './pages/analytics-dashboard';
import AnalyticsScreen from './pages/analytics-screen';
import AdminSettings from './pages/admin-settings';
import AdminBookings from './pages/admin-bookings';
import CRMDashboard from './pages/crm-dashboard';
import SocialBookingForm from './pages/social-booking-form';
import EventsPage from './pages/events';
import InstitutionenBooking from './pages/institutionen';
import EventsAdmin from './pages/events-admin';
import CalendarDebug from './pages/calendar-debug';
import LeadForm from './pages/lead-form';
import LeadDashboard from './pages/lead-dashboard';
import PerspektivePage from './pages/perspektive';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <Tracking />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<MultiStepBookingForm />} />
        <Route path="/multi-step-booking-form" element={<MultiStepBookingForm />} />
        <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
        <Route path="/dashboard" element={<AnalyticsDashboard />} />
        <Route path="/analytics" element={<AnalyticsScreen />} />
        <Route path="/settings" element={<AdminSettings />} />
        <Route path="/admin/bookings" element={<AdminBookings />} />
        <Route path="/crm" element={<CRMDashboard />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/institutionen" element={<InstitutionenBooking />} />
        <Route path="/events-admin" element={<EventsAdmin />} />
        <Route path="/calendar-debug" element={<CalendarDebug />} />
        {/* Facebook-Ads Landingpage: Rückruf-Anfrage ohne Termin (ehem. bewerbung.zba.academy) */}
        <Route path="/bewerbung" element={<LeadForm />} />
        {/* Tag der Perspektive: QR-Code am Stand + Erfassung am ZBA-Tisch (?team) */}
        <Route path="/perspektive" element={<PerspektivePage />} />
        <Route path="/admin/leads" element={<LeadDashboard />} />
        <Route path="/fb" element={<SocialBookingForm channel="fb" />} />
        <Route path="/tg" element={<SocialBookingForm channel="tg" />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
